<template>
  <div
    :class="[
      $style.colors_list,
      size === 'large' && $style['colors_list--large'],
      isScrollable && 'gantt_scroll',
    ]"
    :style="isScrollable ? { maxHeight: scrollMaxHeight } : null"
  >
    <div
      v-for="(color, index) in colors"
      :key="index"
      :class="[
        $style.colors_list_item,
        size === 'large' && $style['colors_list_item--large'],
        itemBorder && $style['colors_list_item--bordered'],
        isSelectedColor(color) && $style['colors_list_item--selected'],
      ]"
      :style="{'background-color': hoverColor === color.id ? color.hex2 : color.hex}"
      @mouseover="hoverColor = color.id"
      @mouseleave="hoverColor = null"
      @click.stop="selectColor(color)"
    >
      <sprite
        v-if="isSelectedColor(color)"
        name="check"
      />
    </div>
  </div>
</template>

<script>
import sprite from '$$uiKitComp/VueIcon/svgSprite.vue';

export default {
  components: {
    sprite,
  },
  props: {
    colors: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    multiselect: {
      type: Boolean,
      default: false,
    },
    itemBorder: {
      type: Boolean,
      default: false,
    },
    onItemSelect: {
      type: Function,
      default: null,
    },
    size: {
      type: String,
      default: 'small',
      validator: v => ['small', 'large'].includes(v),
    },
  },
  emits: ['selectColors'],

  computed: {
    isScrollable() {
      return this.colors.length > 24;
    },

    scrollMaxHeight() {
      return this.size === 'large' ? '168px' : '152px';
    },
  },

  data() {
    return {
      checked: [],
      hoverColor: null,
    };
  },
  watch: {
    selected: {
      handler() {
        this.setSelectedValues();
      },
      deep: true,
    },
  },
  mounted() {
    this.setSelectedValues();
  },
  methods: {
    setSelectedValues() {
      const resolved = this.selected.reduce((acc, item) => {
        if (typeof item === 'number' || typeof item === 'string') {
          const color = this.colors.find(c => c.id === +item);

          if (color) acc.push(color);
        } else {
          acc.push(item);
        }

        return acc;
      }, []);

      this.checked = this.multiselect || !resolved.length ? resolved : [resolved.at(-1)];
    },

    isSelectedColor(color) {
      return this.checked.some(c => c.id === color.id);
    },

    selectColor(color) {
      if (this.multiselect) {
        this.checked = this.isSelectedColor(color)
          ? this.checked.filter(c => c.id !== color.id)
          : [...this.checked, color];
      } else {
        this.checked = [color];
      }

      this.$emit('selectColors', this.checked);

      if (this.onItemSelect) {
        this.onItemSelect(this.checked);
      }
    },
  },
};
</script>

<style module lang="less" src="./colorsList.less"></style>
